import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { combineOpeningHours, DrupalDaysOfWeek } from "./OpeningHours.state";
export const OpeningHoursLayout = (props)=>{
    // Determine the current day of the week
    const today = new Date().getDay();
    const days = Array.from({
        length: 7
    }, (_, i)=>(today + i) % 7); // Thanks, ChatGPT
    return /*#__PURE__*/ _jsx("div", {
        className: "opening-hours__container",
        children: days.map((day)=>{
            const openingHourData = props.items.filter((item)=>item.day === day);
            const open = openingHourData.length > 0 && openingHourData[0].open;
            const additionalInformation = openingHourData.length > 0 ? openingHourData[0].additionalInformation : '';
            const readableTime = openingHourData.length > 0 ? combineOpeningHours(openingHourData).readableTime : '';
            return /*#__PURE__*/ _jsxs("div", {
                className: "opening-hours__wrapper",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "opening-hours__info",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "opening-hours__day",
                                children: DrupalDaysOfWeek[day]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "opening-hours__time",
                                children: open ? readableTime : 'gesloten'
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "opening-hours__text",
                        children: additionalInformation
                    })
                ]
            }, `opening-hours-entry-${day}`);
        })
    });
};
